import { render, staticRenderFns } from "./pieChart.vue?vue&type=template&id=b88fc004&scoped=true"
import script from "./pieChart.vue?vue&type=script&lang=js"
export * from "./pieChart.vue?vue&type=script&lang=js"
import style0 from "./pieChart.vue?vue&type=style&index=0&id=b88fc004&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88fc004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88fc004')) {
      api.createRecord('b88fc004', component.options)
    } else {
      api.reload('b88fc004', component.options)
    }
    module.hot.accept("./pieChart.vue?vue&type=template&id=b88fc004&scoped=true", function () {
      api.rerender('b88fc004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parkCustomer/components/pieChart.vue"
export default component.exports